import * as React from 'react';

type EbProps = {
    children: any;
}


type EbState = {
    hasError: boolean;
}

export default class ErrorBoundary extends React.Component<EbProps,EbState> {
    constructor(props) {
      super(props);
      this.state = { hasError: false};
    }
  
    static getDerivedStateFromError(error) {    
        // Update state so the next render will show the fallback UI.    
        return { hasError: true };  
    }

    handleRedirect = () => {
        setTimeout(() => {
            window.location.href = "/portal/"
        }, 3000);
    }

    componentDidCatch(error, errorInfo) {
            // You can also log the error to an error reporting service
            console.log("Error boundary: "+error);  
            console.log(errorInfo);
    }
    
    render() {
      if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <>
                    <h1>Problema Applicativo. Si prega di attendere...</h1>
                    {this.handleRedirect()}
                     
                </> 
            )
        }
        return this.props.children; 
    }
  }